module.exports = __webpack_public_path__ + "img/data2-1.e4efac10.png";